'use strict';

/*
NOTE: This syntax doesn't work.
require('tablesaw/dist/tablesaw.jquery.js')(window, $);
[CROST]
*/

var $ 				= require('jquery');
var colorbox 		= require('../lib/plaudit.colorbox.js');
var cycle 			= require('jquery.cycle2');
var lightboxOptions = require('../site/siteLightboxOptions.js');

/* This is required for jquery plugins to work correctly [CROST] */
global.jQuery 		= require('jquery');
var cycleCarousel 	= require('jquery.cycle2.carousel');

function addAdditionalImages($elem){
	for (var i=0; i < additionalCarouselImages.length; i++) {
		$elem.append(additionalCarouselImages[i]);
	}
}
function getControls(){
	return '\
		<div class="controls">\
			<button class="control--photos"><span>Photos</span></button>\
			<button class="control--prev"><span>Previous</span></button>\
			<button class="control--next"><span>Next</span></button>\
		</div>';
}
function closeColorbox() {
	$.colorbox.close();
}
function getCarouselOptions() {
	return {
		allowWrap: true,
		speed: 500,
		timeout: 0,
		fx: 'carousel',
		carouselVisible: 3,
		fluid: true,
		next: '.control--next',
		prev: '.control--prev'
	};
}
function getGalleryThumbs() {

}
function getLightboxOptions() {
	return $.extend({}, lightboxOptions, {
		speed: 450,
		width: '100%',
		height: '100%',
		maxWidth: '100%',
		maxHeight: '100%',
		inline: true,
		href: $('.propertyImages__gallery'),
		onComplete: function(){
			$(window).on('resize', closeColorbox);
		},
		onClosed: function(){
			$(window).off('resize', closeColorbox);
		}
	});
	// $.colorbox(options);
}
function init(){
	var $elem = $('.propertyImages__carousel');
	if ($elem.length == 0) {
		return;
	}
	var $galleryThumbs = $('.propertyImages .gallery__thumb');

	addAdditionalImages($elem);

	$elem.append( getControls() );
	$elem.on('cycle-initialized', function( event, opts ) {
		$elem.on('click', '.control--photos', function(event){
			/* because the order is goofy in the markup */
			var slide = opts.currSlide == 0 ? 0 : opts.currSlide + 1;
			console.log(opts.currSlide, slide);
			$($galleryThumbs[slide]).find('a').trigger('click');
			$.colorbox( getLightboxOptions() )
		});
	});
	$elem.cycle( getCarouselOptions() );
}

module.exports = {
	init: init
}
